import {
    AfterContentChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

import * as $ from 'jquery'
import * as moment from 'moment'
import { DatepickerHelper } from '@helpers/datepicker.helper'

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true,
        }],
})
export class DatePickerComponent implements ControlValueAccessor, OnInit, OnDestroy, AfterContentChecked, AfterViewInit {

    // tslint:disable-next-line:no-output-on-prefix
    @Output() onClickDatePicker: EventEmitter<any> = new EventEmitter()

    @Input() hasCustomFunction = false
    @Input() ngModelOptions: object = null
    @Input() inputStyle: object = null
    @Input() isFull = false
    @Input() readonly = false
    @Input() defaultDate: any
    @Input() options: object = DatepickerHelper.BASE_OPTIONS
    @Input() writeEmpty = false
    isPC = true
    hasInit = false
    default_style: object = {
        '-webkit-appearance': 'button-bevel',
        'background-color': '#ffffff',
        position: 'absolute',
        opacity: 0,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    }
    styles: object = {}
    _value: any = null
    showingTime = 100
    @ViewChild('inputElement') private _inputElement: ElementRef
    private $el: JQuery
    private clickToday = false
    private count = 0
    private showingDate: string
    private dateFormat: string
    private isVisible = false

    constructor(private el: ElementRef, private changeDetector: ChangeDetectorRef, private _renderer: Renderer2) {
        if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
            this.isPC = false
        }
    }

    get date() {
        return this._value || null
    }

    set date(val) {
        if (typeof val == 'number') {
            val = moment(val)
        }

        if (this.hasChange(val)) {
            this._value = val

            this._onChange(val)
            if (val) {
                this._onTouched()
            }
            this.hideWidget()
            this.getFormatDate()
            this.changeDetector.markForCheck()
        } else {
            if (this.hasInit && this.clickToday) {
                this.hideWidget()
            }
        }
    }

    ngOnInit(): void {
        this.styles = Object.assign(this.default_style, this.inputStyle)
        this.$el = $(this.el.nativeElement)
    }

    ngAfterContentChecked(): void {
        if (this.isVisible == false && this.el.nativeElement.offsetParent != null) {
            this.isVisible = true
            if (this._value === null && this.defaultDate) {
                this.dateFormat = this.defaultDate
            }
        } else if (this.isVisible == true && this.el.nativeElement.offsetParent == null) {
            this.isVisible = false
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        $(document).off('click')
    }

    writeValue(obj: any): void {        
        if (obj) {
            this.date = obj
        } else {
            if(this.writeEmpty) { 
            this.date = obj
        }
        }
    }

    registerOnChange(fn: any): void {
        this._onChange = fn
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {
        this._renderer.setProperty(this._inputElement.nativeElement, 'disabled', isDisabled)
    }

    onChange(event: any) {
        this._onChange(event.target.value)
    }

    onKeyup(event: any) {
        this._onChange(event.target.value)
    }

    onBlur(event: any) {
        this._onTouched()
    }

    isOpen() {
        return this.getWidgetSelector().is(':visible')
    }

    nextDate(num) {
        this.addDate(num)
    }

    prevDate(num) {
        this.addDate('-' + num)
    }

    addDate(num) {
        if (this.readonly) {
            return
        }
        if (num != 0) {
            const adDate = moment(this.date)
            this.date = moment(adDate['_d']).add(num, 'days').startOf('day').valueOf()
            this.getFormatDate()
        }
    }

    getFormatDate() {
        this.dateFormat = moment(this.date).format(DatepickerHelper.DATE_FORMAT)
    }

    datePickerClick() {
        if (this.readonly) {
            return
        }
        const $widget = this.getWidgetSelector()
        if (!this.isOpen()) {
            $widget.show()
        }
        setTimeout(() => {
            if (!this.hasInit || this.isOpen()) {
                this.hasInit = true
                if (this.hasCustomFunction) {
                    const $changeBtns = $(this.el.nativeElement).find('.datepicker .prev , .datepicker .next, .datepicker .month')
                    $widget.css({ 'z-index': 9999 })
                    // callback
                    this.onClickDatePicker.emit()
                    $changeBtns.off('click')
                    $changeBtns.click(() => {
                        setTimeout(() => {
                            this.onClickDatePicker.emit()
                        }, this.showingTime)
                    })
                }
                this.triggerCloseOnClickOutside()
                this.hideOnSelectDate()
            } else {
                // $widget.hide();
            }
        }, this.showingTime)
    }

    hideOnSelectDate() {
        const $el = $(this.el.nativeElement)
        // days is show
        if (this.$el.find('.datepicker-days').is(':visible')) {
            const $dayBtns = $el.find('.datepicker .day, .bootstrap-datetimepicker-widget [data-action=\'today\']')
            $dayBtns.one('click', (event) => {
                this.clickToday = $(event.target).closest('[data-action="today"]').length == 1 || $(event.target).hasClass('active')
                setTimeout(() => {
                    this.hideWidget()
                }, this.showingTime)
            })
        } else {
            // tslint:disable-next-line:no-unused-expression
            this.moreClick('month') || this.moreClick('year') || this.moreClick('day') || this.moreClick('decade')
        }
    }

    moreClick(ele = 'year') {
        if (this.$el.find(`.datepicker-${ ele }s`).is(':visible')) {
            const $btns = this.$el.find(`.datepicker .${ ele }`)
            $btns.one('click', () => {
                setTimeout(() => {
                    this.hideOnSelectDate()
                }, this.showingTime)
            })

            return true
        }
    }

    hasChange(val) {
        if (this.clickToday) {
            this.clickToday = false
            return true
        }
        let curentVal = this._value
        let newVal = val
        if (this._value && typeof this._value !== 'string') {
            curentVal = this._value.format(DatepickerHelper.DATE_FORMAT)
        }
        if (val && typeof val !== 'string') {
            newVal = val.format(DatepickerHelper.DATE_FORMAT)
        }

        return curentVal != newVal
    }

    private _onChange = (_: any) => {
    }

    private _onTouched = () => {
    }

    private hideWidget() {
        if (this.isOpen()) {
            this.getWidgetSelector().hide()
            $(document).off('click')
        }
    }

    private getWidgetSelector() {
        return $(this.el.nativeElement).find('.bootstrap-datetimepicker-widget')
    }

    private triggerCloseOnClickOutside() {
        $(document).click(e => {
            const $el = this.el.nativeElement
            if ($(e.target).closest($el).length == 0) {
                this.hideWidget()
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/date-picker/date-picker.component.ts